import * as STD  from '@emersya/mpa-std';
import * as CM   from '@emersya/mpa-components-manager';

export interface IDevToolsEventComponentConfiguration extends CM.DOMComponent.IConfiguration {
	type: string;
	subType: string;
	content: string;
	time: Date;
};

export class DevToolsEventComponent extends CM.DOMComponent<
	HTMLDivElement,
	DevToolsEventComponent,
	IDevToolsEventComponentConfiguration
> {
	component_DOM: HTMLDivElement;

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IDevToolsEventComponentConfiguration
	) {
		super(descriptor, configuration);

		const dateRepr = [
			configuration.time.getHours().toString().padStart(2, '0'),
			configuration.time.getMinutes().toString().padStart(2, '0'),
			configuration.time.getSeconds().toString().padStart(2, '0'),
			configuration.time.getMilliseconds().toString().padStart(3, '0')
		].join(':');

		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			tag: 'li',
			childs: [
				{
					childs: [
						{ tag: 'span', classList: ['type'], text: configuration.type + '(' },
						{ tag: 'span', classList: ['subType'], text: configuration.subType },
						{ tag: 'span', classList: ['type'], text: '): ' }
					]
				},
				{ text: configuration.content, classList: ['content'] },
				{ text: dateRepr, classList: ['date'] }
			]
		});
	}

};
export namespace NS {
	export const Component = DevToolsEventComponent;
	export type Component = DevToolsEventComponent;
	export type Configuration = IDevToolsEventComponentConfiguration;
}
import manifestXMLSource          from './DevToolsEvent.xml';

CM.Manager.declare({
	id: 'devTools-event',
	type: DevToolsEventComponent,
	manifest: manifestXMLSource
});
